import { STATIC_URL } from 'constants/data'

const imgData = {
  width: 353,
  height: 280,
  src: `${STATIC_URL}/crowd-funding/vblagodarnost_icon_2.png`,
  alt: 'Логотип',
  unoptimized: true,
}

const logoData = {
  width: 148,
  height: 26,
  src: `${STATIC_URL}/crowd-funding/top-logo_black.png`,
  alt: 'лого',
  unoptimized: true,
}

export { imgData, logoData }
